import { Component, OnInit } from '@angular/core';
import { DataGridTemplate, } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PressService, PlantService, AttachmentService } from '../../../phf/phf.service';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';
import { S3Service } from '../../../../shared/services/s3.service';
import { RowHeightService } from '@progress/kendo-angular-grid/dist/es2015/scrolling/row-height.service';

const enterComponentName = 'Enter a Component Name';

@Component({
  selector: 'app-press',
  templateUrl: './press.component.html'
})
export class PressComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  parts: any;
  plants: any;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly plantService: PlantService,
    private readonly pressService: PressService,
    private readonly s3Service: S3Service,
    private readonly attachmentService: AttachmentService
  ) {
    super();
  }

  ngOnInit() {
    this.httpErrorHeader =  "Press Error";
    this.deleteValidation = true;
    this.filterable = "menu";
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.formDialog.setHeight(640);
    this.formDialog.largeForm = true;
    this.resizable = true;
    this.controls.excel = true;
    this.controls.configure = true;
    this.editForm = this.formBuilder.group({
      Id: [],
      Class: ['', Validators.required],
      IsActive: [],
      PlantId: ['', Validators.required],
      Name: [],
      Number: ['', Validators.required], //Press Id
      FOLSystem: [],
      PlantName: [],
      RoboticLoading: [],
      AvailableAssist: [],
      ImageTeamcenterURL: [],
      AttachmentId: [],
      ImagePath: [],
      pressInput: [],
      DisplayPlant: [],
      TotalNumberOfWorkStations: [],
      thumbnail: [],
      SystemMax: [],

      PressTypeGroup: [],
      Type: ['', Validators.required],
      PressNote: [],
      PressMax: [],

      FOLTypeGroup: [],
      FOLType: [],
      FOLNote: [],
      FOLMax: [],

      TransferTypeGroup: [],
      TransferType: [],
      TransferNote: [],
      TransferMax: [],

      SystemMaxGroup: [],
      SystemTargetSPM: [],
      TruckTarget: [],
      TruckMax: [],

      EOLTypeGroup: [],
      EOLType: [],
      EOLNote: [],
      EOLMax: [],

      DesignRateGroup: [],
      TargetSPM: [],
      HandlingTarget: [],
      HandlingMax: [],

      ObservedSystemRestriction: [],
      EquipmentRestriction: [],
      ObservedEquipmentRestriction: [],
    });
    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);

    this.dialogTitle.next('Press');

    this.plantService.read();
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }


  read(opts: any): Promise<any> {
    return opts.force ?
      this.pressService.read('')
        .then(response => this.mapPressResponse(response))
      : Promise.resolve(this.pressService.value);
  }


  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
    this.editDataItem.IsActive = true;
    this.editDataItem.RoboticLoading = false;
    this.editDataItem.AvailableAssist = false;
  }


  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    if (dataItem.AttachmentId) {
      this.attachmentService.read('/' + dataItem.AttachmentId)
        .then(response => {
          const filePath = response.Path.charAt(response.Path.length - 1) != '/'? response.Path + '/' + response.FileName: response.Path + response.FileName;
          this.formDialog.editForm.get('thumbnail').setValue(this.s3Service.getS3Path(filePath))
        })
    }
    this.formDialog.next(dataItem);
    this.handleSystemMax();
  }


  save(dataItem: any, isNew: boolean): Promise<any> {
    let s3Promise;
    let pressImgUploadPromise;
    let pressPromise;
    const isNewAttachment = dataItem.AttachmentId === null;
    const img = this.formDialog.imagePreviews;
    let s3Path, requestBody;
    if (img.length > 0) {
      s3Path = 'PHF/PressPictures/';
      requestBody = {
        "FileName": img[0].name,
        "FileDescription": '',
        "Path": s3Path
      };
    }

    if (isNew) {
      pressPromise = this.pressService.save(dataItem, isNew, "", false)
        .then(response => {
          if (img.length > 0) {
            s3Promise = this.s3Service.handleS3Upload(img, s3Path);
            pressImgUploadPromise = this.pressService.save(requestBody, isNewAttachment, '/UploadPressLineAttachment?pressId=' + response)
          }
        })
    }
    else {
      const uploadPath = `/UploadPressLineAttachment?pressId=${dataItem.Id}`;
      const updatePath = `/UpdatePressAttachment/${this.editForm.get('Id').value}/${this.editForm.get('AttachmentId').value}`;
      const servicePath = isNewAttachment ? uploadPath : updatePath;
      if (img.length > 0) {
        s3Promise = this.s3Service.handleS3Upload(img, s3Path);
        pressImgUploadPromise = this.pressService.save(requestBody, isNewAttachment, servicePath)
      }
      pressPromise = this.pressService.save(dataItem, isNew, "/" + dataItem.Id, false);
    }

    return Promise.all([s3Promise, pressImgUploadPromise, pressPromise]);
  }

  delete(dataItem: any): Promise<any> {
    return this.pressService.remove("/" + dataItem.Id);
  }

  deleteValidationService = (dataItem: any): Promise<string> => {
    return this.pressService.read('/GetActiveParts/' + dataItem.Id, true)
      .then(response => {
        const numParts = response.Parts;
        if (numParts !== 0) {
          return `Are you sure you want to delete ${dataItem.Class}? ${dataItem.Class} has ${numParts} parts associated with it.`;
        }
        else {
          return `Are you sure you want to delete ${dataItem.Class}?`;
        }
      });
  }

  handleSystemMax = () => {
    const maxArray = [this.editForm.get('PressMax').value, this.editForm.get('FOLMax').value, this.editForm.get('TransferMax').value, this.editForm.get('EOLMax').value];
    const minvalue = Math.min(...maxArray);
    this.editForm.get('SystemMax').setValue(minvalue);
  }

  handleUploadSelect = (e) => {
    const that = this.formDialog;

    e.files.forEach((file) => {

      if (!file.validationErrors) {
        const reader = new FileReader();

        reader.onload = (ev) => {
          const image = {
            src: (ev.target as FileReader).result,
            uid: file.uid,
            name: file.name,
            state: file.state,
            rawFile: file.rawFile,
          };
          that.imagePreviews.unshift(image);
        };

        reader.readAsDataURL(file.rawFile);
      }
    });
  }


  private mapNullField(check) {
    return check === null ? "none" : parseFloat(check).toFixed(2);

  }


  private mapPressResponse(response) {
    return response.map(item => {
      //these if checks replace nulls, with none for appearence purposes
      item.PressMaxString = this.mapNullField(item.PressMax);
      item.TargetSPMString = this.mapNullField(item.TargetSPM);
      item.SystemMaxString = this.mapNullField(item.SystemMax);
      item.EquipmentRestrictionString = this.mapNullField(item.EquipmentRestriction);
      item.ObservedEquipmentRestrictionString = this.mapNullField(item.ObservedEquipmentRestriction);
      return item;
    });
  }


  columns: any[] = [

    {
      field: 'Number',
      title: 'Press Id',
    },
    {
      field: 'Type',
      title: 'Press Type',
    },
    {
      field: 'Class',
      title: 'Press Class',
    },
    {
      field: 'PlantName',
      title: 'Plant',
    },
    {
      field: 'PressNote',
      title: 'Press Note',
    },
    {
      field: 'PressMaxString',
      title: 'Press Max (SPM)',
    },
    {
      field: 'TargetSPMString',
      title: 'Target (SPM)',
    },
    {
      field: 'SystemMaxString',
      title: 'Press System Max (SPM)',
    },
    {
      field: 'EquipmentRestrictionString',
      title: 'Equipment Restriction',
    },
    {
      field: 'ObservedEquipmentRestrictionString',
      title: 'Observed Equipment Restriction',
    },
    {
      field: 'TotalNumberOfWorkStations',
      title: 'Total # Work Stations',
    }
  ]


  formControls = [
    {
      type: "text",
      name: "Number",
      title: "Press Id",
      stretch: true,
    },
    {
      type: "text",
      name: "Class",
      title: "Class",
      stretch: true,
    },
    {
      type: "combobox",
      name: "PlantId",
      service: this.plantService,
      title: "Plant",
      textField: "Name",
      valueField: "Id",
      stretch: true,
    },
    {
      type: "boolean",
      title: "Auto-capable",
      name: "RoboticLoading",
      stretch: true,
    },
    {
      type: "boolean",
      title: "Available Assist",
      name: "AvailableAssist",
      stretch: true,
    },
    {
      type: "thumbnail",
      title: "Press Image",
      name: "thumbnail",
      zoomin: {
        height: 700,
        width: 700,
      },
      stretch: true,
    },
    {
      type: "upload",
      name: "ImagePath",
      title: "Upload Press Image",
      select: this.handleUploadSelect,
      multiple: false,
      stretch: true,
    },
    {
      type: "text",
      name: "ImageTeamcenterURL",
      title: "Teamcenter Press Image URL",
      stretch: true,
    },
    {
      type: "number",
      name: "TotalNumberOfWorkStations",
      title: "Total # of Work Stations",
      stretch: true,
    },
    {
      type: "group",
      name: "PressTypeGroup",
      stretch: true,
      title: "Press Type Group",
      subControls: [
        {
          type: 'text',
          title: 'Press Type',
          name: 'Type',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'textarea',
          title: 'Press Note',
          name: 'PressNote',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'Press SPM Max',
          name: 'PressMax',
          placeholder: enterComponentName,
          invalidText: '',
          onChange: this.handleSystemMax,
        },
      ]

    },

    {
      type: "group",
      name: "FOLTypeGroup",
      stretch: true,
      title: "FOL Type Group",
      subControls: [
        {
          type: 'text',
          title: 'FOL Type',
          name: 'FOLType',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'textarea',
          title: 'FOL Note',
          name: 'FOLNote',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'FOL Max',
          name: 'FOLMax',
          placeholder: enterComponentName,
          invalidText: '',
          onChange: this.handleSystemMax,
        },
      ]

    },
    {
      type: "group",
      name: "TransferTypeGroup",
      stretch: true,
      title: "",
      subControls: [
        {
          type: 'text',
          title: 'Transfer Type',
          name: 'TransferType',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'textarea',
          title: 'Transfer Note',
          name: 'TransferNote',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'Transfer Max',
          name: 'TransferMax',
          placeholder: enterComponentName,
          invalidText: '',
          onChange: this.handleSystemMax,
        },
      ]

    },
    {
      type: "group",
      name: "EOLTypeGroup",
      stretch: true,
      title: "",
      subControls: [
        {
          type: 'text',
          title: 'EOL Type',
          name: 'EOLType',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'textarea',
          title: 'EOL Note',
          name: 'EOLNote',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'EOL Max',
          name: 'EOLMax',
          placeholder: enterComponentName,
          invalidText: '',
          onChange: this.handleSystemMax,
        },
      ]

    },
    {
      type: "group",
      name: "SystemMaxGroup",
      stretch: true,
      title: "",
      subControls: [
        {
          type: 'number',
          title: 'Press System Max (SPM): ',
          name: 'SystemMax',
          placeholder: enterComponentName,
          invalidText: '',
          readonly: true,
          class: 'rightcolumn number-input group',
          spinner: false,
        },
      ]
    },
    {
      type: "group",
      name: "DesignRateGroup",
      stretch: true,
      title: "",
      subControls: [
        {
          type: 'number',
          title: 'Design Rate / Press Target (SPM) (ref)',
          name: 'TargetSPM',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'Handling Template',
          name: 'HandlingTarget',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'Handling Max',
          name: 'HandlingMax',
          placeholder: enterComponentName,
          invalidText: '',
        },
      ]
    },
    {
      type: "group",
      name: "SystemMaxGroup",
      stretch: true,
      title: "",
      subControls: [
        {
          type: 'number',
          title: 'Design Rate System Target (SPM) (ref)',
          name: 'SystemTargetSPM',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'Truck Template',
          name: 'TruckTarget',
          placeholder: enterComponentName,
          invalidText: '',
        },
        {
          type: 'number',
          title: 'Truck Max',
          name: 'TruckMax',
          placeholder: enterComponentName,
          invalidText: '',
        },
      ]
    },
    {
      type: "group",
      name: "ObservedSystemRestriction",
      stretch: true,
      title: "",
      subControls: [
        {
          type: 'number',
          title: "Plant Obs. System Max (ref)",
          name: "ObservedEquipmentRestriction",
          placeholder: enterComponentName,
          invalidText: '',
        },
      ]
    },
  ]
  formDialogTabs = [
    {
      title: "Press",
      selected: true,
      formControls: this.formControls
    },
  ]
}
